import { render, staticRenderFns } from "./horarios.vue?vue&type=template&id=6cd2fc58&"
import script from "./horarios.vue?vue&type=script&lang=js&"
export * from "./horarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports